import React from 'react';
import Markdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import rehypeSanitize from 'rehype-sanitize';

export default function DegreeDescription(props) {
  const { description, transferable } = { ...props };

  return description?.includes('</') ? (
    <div className="degree-description">
      <Markdown rehypePlugins={[rehypeRaw, rehypeSanitize]}>
        {description.replace(/“|”/gi, '"').trim()}
      </Markdown>
    </div>
  ) : (
    <div className="degree-description">
      {description}
      {transferable ? (
        <div className="degree-transferable">
          * This associate degree transfers to a bachelor's degree which may be
          required for certain careers.
        </div>
      ) : null}
    </div>
  );
}
